module.exports = __webpack_public_path__ + "static/lerna-hero-4295c08d8ff3f44bb140b0e876b51971.svg";